import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../button/button';
import { SimpleFlexbox } from '../../flexbox/flexbox';

const CompareButton = ({ isActive, handleClick }) => (
    <SimpleFlexbox display="flex" flex={1} itemsCenter="xs" contentCenter="xs" margin="left_right_xsmall">
        <Button
            onClick={handleClick}
            tagName="button"
            label="Start Comparing"
            icon="ctm_angle_right"
            UIComponent={isActive ? 'btn_secondary_xlarge_semi_rounded' : 'btn_secondary_xlarge_semi_rounded_inactive'}
            variant="full_width"
        />
    </SimpleFlexbox>
);

CompareButton.propTypes = {
    isActive: PropTypes.bool,
    handleClick: PropTypes.func.isRequired
};

export { CompareButton };
